import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import { Toaster } from '@/components/ui/sonner';
import { LanguageProvider } from '@/lib/contexts/LanguageContext';
import '@/styles/globals.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <LanguageProvider>
      <App />
      <Toaster />
    </LanguageProvider>
  </StrictMode>,
);
